// 商品一覧のバリエーション画像の切り替え
  /**
  * 商品一覧カード（li.grid__item）内の .card__variant_images のthumbをクリックしたら
  * .card__media 内のメイン画像を差し替える
  */
  (function () {
  // 二重初期化防止
  if (window.__imageSwitcherV2Initialized) return;
  window.__imageSwitcherV2Initialized = true;

  // クリック委譲（リスト全体に対して1回だけリスナーを置く）
  document.addEventListener('click', function (event) {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  // 対象: バリエーションthumb（IMG）が .card__variant_images 配下にあること
  if (target.tagName !== 'IMG') return;
  const variantWrap = target.closest('.card__variant_images');
  if (!variantWrap) return;

  // カード（li.grid__item）を特定
  const card = target.closest('li.grid__item');
  if (!card) return;

  // 置換先URLを取得（data-productimage が前提。なければ src をfallback）
  const nextUrl =
  target.getAttribute('data-productimage') ||
  target.dataset.productimage ||
  target.getAttribute('data-image') ||
  target.getAttribute('data-src') ||
  target.src ||
  '';

  if (!nextUrl) return;

  // メイン画像を取得（.card__media 内の <img>）
  const mainImg =
  card.querySelector('.card__media img') ||
  card.querySelector('.media img') ||
  card.querySelector('img.motion-reduce');

  if (mainImg) {
  // <picture>構成にも一応対応（あれば <source> の srcset も同一URLで上書き）
  const picture = mainImg.closest('picture');
  if (picture) {
  picture.querySelectorAll('source').forEach((s) => {
  s.srcset = nextUrl;
});
}
  mainImg.src = nextUrl;
  mainImg.srcset = nextUrl;
  mainImg.loading = 'eager';
  mainImg.decoding = 'sync';
}

  // currentクラスの更新（同一カード内だけで切り替え）
  variantWrap.querySelectorAll('img').forEach(img => img.classList.remove('current'));
  target.classList.add('current');
}, false);

  // 公開API（必要なら外部から初期整形などで呼べます）
  window.setupImageSwitcher = function () {
  // 今回は委譲方式なので特に処理不要
  // 初期状態でcurrentが無ければ先頭に付与する等の整形が必要ならここに追記
};
})();

// FAQ
var dtElements = document.querySelectorAll('.faqWrap dt');
dtElements.forEach(function (element) {
  element.addEventListener('click', function (event) {
    event.target.classList.toggle('open');
  });
});

// ヘッダースティッキー
if (document.querySelector('.sticky-header_all') != null) {
  const sticky_header_all = document.querySelector('.sticky-header_all');
  const sticky_padding = document.querySelector('.sticky_padding');
  let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
  let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
  let sticky_header_all_height = sticky_header_all.clientHeight;
  let sticky_header_Animation = function () {
    let header_scroll_position = window.pageYOffset;
    if (header_scroll_position > sticky_header_allTop_position) {
      sticky_header_all.classList.add('sticky_on');
      sticky_padding.style.paddingTop = sticky_header_all_height + "px";
      sticky_padding.classList.add('sticky_on');
    } else {
      sticky_header_all.classList.remove('sticky_on');
      sticky_padding.style.paddingTop = "0";
      sticky_padding.classList.remove('sticky_on');
    }
  }
  window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if (document.getElementById("side_to_top_btn_sec") != null) {
  const pageTop = document.getElementById('side_to_top_btn_sec');
  const pageTopBtn1 = document.getElementById('side_to_top_btn');
  let Animation = function () {
    //アイコン位置取得

    //要素の位置座標を取得
    let rect = pageTop.getBoundingClientRect();
    //topからの距離
    let scrollTop = rect.top + window.pageYOffset;

    if (scrollTop > 600) {
      pageTop.classList.add('show');
    } else {
      pageTop.classList.remove('show');
    }
  }
  window.addEventListener('scroll', Animation);
  pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if (document.getElementById("footer_to_top_btn") != null) {
  const pagetopBtn = document.querySelector('#footer_to_top_btn');
  pagetopBtn.addEventListener("click", scroll_top);
}
;

function scroll_top() {
  window.scrollTo(0, 0);
}


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function () {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).on("mousedown", function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });

    $(e).on("mousemove", function (event) {
      if ($(e).data("down")) {
        event.preventDefault();
        let move_x = $(e).data("x") - event.clientX;
        let move_y = $(e).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(e).data("move", true);
        } else {
          return;
        }
        $(e).scrollLeft($(e).data("scrollleft") + move_x);
        $(e).scrollTop($(e).data("scrolltop") + move_y);
        return false;
      }
    });

    $(e).on("mouseup", function (event) {
      if ($(e).data("down")) {
        $(e).data("down", false);
        return false;
      }
    });

    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
};


$(".multiGrid").mousedragscrollable();


//商品詳細ページのタブ切り替え
$(function () {
  //$('.descriptionTab')が存在する場合に下記を実行
  if ($('.descriptionTab').length) {
    //$('.descriptionTab .tabContent--A')が存在する場合、1番目のtab_containerの中身に移動させる
    if ($('.descriptionTab .tabContent--A').length) {
      $('.descriptionTab .tabContent--A').appendTo($('.descriptionTab .tab__container.--A'));
    }
    //$('.descriptionTab .tabContent--B')が存在する場合、2番目のtab_containerの中身に移動させる
    if ($('.descriptionTab .tabContent--B').length) {
      $('.descriptionTab .tabContent--B').appendTo($('.descriptionTab .tab__container.--B'));
    }
  }

  $('.descriptionTab .tab__head span').click(function () { // クリックイベントを設定する
    $(this).addClass('is-active'); // クリックされたタブをアクティブにする
    $(this).siblings().removeClass('is-active'); // 兄弟要素のアクティブを解除する
    $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').eq($(this).index()).addClass('is-active'); // クリックされたタブに対応するコンテンツを表示する
    $(this).closest('.tab__head').next('.tab__containerWrap').children('.tab__container').not(':eq(' + $(this).index() + ')').removeClass('is-active'); // クリックされたタブ以外のコンテンツを非表示にする
  });
});


//サイドメニュー
//アコーディオンボタン
$(function () {
  $('.accordionButton').click(function () {
    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', true);
      $(this).next().slideDown();
    } else {
      $(this).attr('aria-expanded', false);
      $(this).next().slideUp();
    }
  });
});

////header-typeE
// ナビゲーション 子要素展開
$(function () {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0 || ua.indexOf('iPad') > 0) {
    $('.hasChildren > a').on('mouseenter touchstart', function () {
      $(this).toggleClass('open');
      $(this).next('ul,.megaMenu').toggleClass('open');
      return false;
    }).on('mouseleave touchend', function () {
      return false;
    });
    $('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function () {
      $(this).parents('ul').removeClass('open').prev('a').removeClass('open');
      return false;
    });

  } else {
    // PC時
    $('.hasChildren').hover(function () {
      $(this).children('a').addClass('open');
      $(this).children('ul,.megaMenu').addClass('open');
    }, function () {
      $(this).children('a').removeClass('open');
      $(this).children('ul,.megaMenu').removeClass('open');
    });
  }
});

// 検索ランキングキーワード
$(function () {
  // テキストボックスにフォーカス時、フォームの背景色を変化
  $('.search-header__form input[type="product"]')
    .focusin(function (e) {
      $(this).parents().next('.keywordRanking__toggle').addClass('open');
    })
    .focusout(function (e) {
      setTimeout(function () {
        $('.keywordRanking__toggle.open').removeClass('open');
      }, 200);
    });
});

//user-guide用
$(document).on("click", ".hasChildren--clickSP > h2", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 1001) {
    var next = $(this).next();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      next.removeClass("open");
      next.slideUp();
    } else {
      const all = $(this)
        .parents("li")
        .parents()
        .parents(".gNav")
        .find(".hasChilds > span");
      all.removeClass("open");
      all.next().removeClass("open").slideUp(0);
      $(this).addClass("open");
      next.addClass("open").slideDown();
    }
    return false;
  }
});

//独自実装ハンバーガー
$(function () {
  $('.h_menu').click(function () {
    $('.drawer_wrap').toggleClass('open');
    $(this).toggleClass('active');
  });
  $('.close_btn').click(function () {
    $('.drawer_wrap').removeClass('open');
    $('.h_menu').removeClass('active');
  });
});

// オープニングアニメーション
function setCookie(name, value, seconds) {
  const d = new Date();
  d.setTime(d.getTime() + seconds * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

document.addEventListener("DOMContentLoaded", function () {
  const first = document.querySelector(".opening_visual .first");
  const second = document.querySelector(".opening_visual .second");
  const opening = document.querySelector(".opening_visual");
  const mainContent = document.getElementById("main-content");
  const moreBtn = document.getElementById("more-btn");

  const isHome = window.location.pathname === "/" || window.location.pathname === "/index.html";
  const referrer = document.referrer;
  const isSameSiteReferrer = referrer && referrer.indexOf(location.hostname) !== -1;

  // Shopifyプレビュー時はスキップ
  if (window.Shopify && Shopify.designMode) {
    if (opening) opening.style.display = "none";
    if (mainContent) mainContent.style.display = "block";
    return;
  }

  // トップページ以外でクッキーがある場合 → スキップ
  if (!isHome && getCookie("opening_viewed") === "yes") {
    if (opening) opening.style.display = "none";
    if (mainContent) mainContent.style.display = "block";
    return;
  }

  // トップページの場合の表示条件
  // 外部サイトから来た場合のみ表示（同一サイト内から来た場合はスキップ）
  if (isHome && !isSameSiteReferrer) {
    first.classList.add("active");

    setTimeout(() => {
      first.classList.remove("active");
      second.classList.add("active");

      // トップページでは毎回表示したいのでクッキーはセットしない
    }, 3000);
  } else {
    // 同一サイト内からのTOPアクセス時はスキップ
    if (opening) opening.style.display = "none";
    if (mainContent) mainContent.style.display = "block";
    return;
  }

  // 「もっと見る」ボタン動作
  moreBtn.addEventListener("click", function (e) {
    e.preventDefault();
    if (opening) opening.style.display = "none";
    if (mainContent) mainContent.style.display = "block";
  });
});


//SVG用
document.addEventListener('DOMContentLoaded', () => {
  const imgWraps = document.querySelectorAll('.img_wrap');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const imgWrap = entry.target;

      const anim01Paths = imgWrap.querySelectorAll('.anim01 svg path');
      const anim02Paths = imgWrap.querySelectorAll('.anim02 svg path');

      if (entry.isIntersecting) {
        anim01Paths.forEach((path, index) => {
          const delay = 0.2 + index * 0.15;
          path.style.transition = `fill 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) ${delay}s`;
          path.style.fill = '#fff';
        });

        const totalAnim01Delay = 0.2 + (anim01Paths.length - 1) * 0.15 + 0.3;
        setTimeout(() => {
          anim02Paths.forEach((path, index) => {
            const delay = 2 + index * 0.15;
            path.style.transition = `fill 0.3s cubic-bezier(0.47, 0, 0.745, 0.715) ${delay}s`;
            path.style.fill = '#fff';
          });
        }, totalAnim01Delay * 1000);
      } else {
        [...anim01Paths, ...anim02Paths].forEach(path => {
          path.style.transition = '';
          path.style.fill = '';
        });
      }
    });
  }, {threshold: 0.6});

  imgWraps.forEach(imgWrap => observer.observe(imgWrap));
});


// document.addEventListener('DOMContentLoaded', () => {
//   const animWhite = document.querySelectorAll('.anim_white');

//   animWhite.forEach(animWhite => {
//     const paths = animWhite.querySelectorAll('svg path');
//     let timeoutId = null;

//     animWhite.addEventListener('mouseenter', () => {
//       // ホバー中にmouseleave→mouseenterが続いた場合に備えてリセット
//       clearTimeout(timeoutId);

//       paths.forEach((path, index) => {
//         const delay = 0.15 + index * 0.1;
//         path.style.fill = '#fff';
//         path.style.transition = `fill 0.1s cubic-bezier(0.47, 0, 0.745, 0.715) ${delay}s`;
//       });
//     });

//     animWhite.addEventListener('mouseleave', () => {
//       timeoutId = setTimeout(() => {
//         paths.forEach(path => {
//           path.style.fill = '';
//           path.style.transition = '';
//         });
//       }, 300); // 0.3秒（300ms）後にリセット
//     });
//   });
// });
document.addEventListener('DOMContentLoaded', () => {
  const animWhiteEls = document.querySelectorAll('.anim_white');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const animWhite = entry.target;
        const paths = animWhite.querySelectorAll('svg path');

        paths.forEach((path, index) => {
          const delay = 0.15 + index * 0.1;
          path.style.fill = '#fff';
          path.style.transition = `fill 0.1s cubic-bezier(0.47, 0, 0.745, 0.715) ${delay}s`;
        });

        // 1回だけ発火させる場合は監視解除
        obs.unobserve(animWhite);
      }
    });
  }, {
    root: null,       // ビューポート基準
    threshold: 0.4    // 10%以上見えたら実行
  });

  animWhiteEls.forEach(el => observer.observe(el));
});


// document.addEventListener('DOMContentLoaded', () => {
//   const animBlack = document.querySelectorAll('.anim_black');

//   animBlack.forEach(animBlack => {
//     const anims = animBlack.querySelectorAll('.anim'); // anim_under01~03
//     let timeoutId = null;

//     animBlack.addEventListener('mouseenter', () => {
//       clearTimeout(timeoutId);

//       anims.forEach((anim, animIndex) => {
//         const paths = anim.querySelectorAll('svg path');

//         const animDelay = animIndex * 0.8; // アニメ間隔

//         paths.forEach((path, pathIndex) => {
//           const delay = animDelay + pathIndex * 0.1; // パス間隔
//           path.style.fill = '#000';
//           path.style.transition = `fill 0.4s ease-in-out ${delay}s`;
//         });
//       });
//     });

//     animBlack.addEventListener('mouseleave', () => {
//       timeoutId = setTimeout(() => {
//         anims.forEach(anim => {
//           const paths = anim.querySelectorAll('svg path');
//           paths.forEach(path => {
//             path.style.fill = '';
//             path.style.transition = '';
//           });
//         });
//       }, 300);
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const animEls = document.querySelectorAll('.anim_black .anim'); // anim_under01~03 など

  const runAnimation = (anim, animIndex = 0) => {
    const paths = anim.querySelectorAll('svg path');
    const animDelay = 0.8; // アニメ間隔（必要なら残す）

    paths.forEach((path, pathIndex) => {
      const delay = animDelay + pathIndex * 0.1; // パス間隔
      path.style.fill = '#000';
      path.style.transition = `fill 0.4s ease-in-out ${delay}s`;
    });
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const anim = entry.target;
        // 親の中で何番目の anim かを調べたい場合
        const parent = anim.closest('.anim_black');
        const siblings = parent ? [...parent.querySelectorAll('.anim')] : [];
        const animIndex = siblings.indexOf(anim);

        runAnimation(anim, animIndex);

        // 1回きりなら監視解除
        obs.unobserve(anim);
      }
    });
  }, {
    root: null,
    threshold: 0.4 // 40% 以上見えたら発火
  });

  animEls.forEach(el => observer.observe(el));
});


//ロゴ、ハンバーガー等白黒切り替え用
document.addEventListener("DOMContentLoaded", function () {
  const headerWrapper = document.querySelector("#header .header-wrapper");
  const targets = document.querySelectorAll(".sec_about .wh, .img_wide");

  if (!headerWrapper || targets.length === 0) return;

  const headerHeight = headerWrapper.offsetHeight;
  const offsetHeader = 50;   // header-wrapper 用
  const offsetBody = 450;  // body 用 (header より400px先)
  const body = document.body;

  function checkHeader() {
    let isHeaderActive = false;
    let isBodyActive = false;

    targets.forEach(target => {
      const rect = target.getBoundingClientRect();
      // header 判定
      if (rect.top < headerHeight + offsetHeader && rect.bottom > offsetHeader) {
        isHeaderActive = true;
      }
      // body 判定（header より400px先）
      if (rect.top < headerHeight + offsetBody && rect.bottom > offsetBody) {
        isBodyActive = true;
      }
    });

    // header-wrapper の制御
    if (isHeaderActive) {
      headerWrapper.classList.add("wh-change");
    } else {
      headerWrapper.classList.remove("wh-change");
    }

    // body の制御
    if (isBodyActive) {
      body.classList.add("wh-change");
    } else {
      body.classList.remove("wh-change");
    }
  }

  window.addEventListener("scroll", checkHeader);
  window.addEventListener("resize", checkHeader);
  checkHeader(); // 初期チェック
});


//独自実装スライダー、header-wrapperにスライダーの色判定を連動させる(ロゴ、ハンバーガー等白黒切り替え用)
jQuery(document).ready(function ($) {
  const headerWrapper = $('#header .header-wrapper');
  const body = $('body');
  if (!headerWrapper.length) return;

  const fadeSwiper = new Swiper('.MV', {
    effect: 'fade',
    fadeEffect: {crossFade: true},
    loop: true,
    autoplay: {delay: 5000, disableOnInteraction: false},
    speed: 800,
  });

  const scrollTargets = document.querySelectorAll('.sec_about .wh, .img_wide');
  const headerHeight = headerWrapper.outerHeight();
  const offsetHeader = 50;   // header-wrapper 用
  const offsetBody = 450;  // body 用

  const sliderArea = document.querySelector('.MV');

  function updateHeader() {
    // Swiper 判定
    const activeSlide = $(fadeSwiper.slides[fadeSwiper.activeIndex]);
    let swiperActive = false;
    if (activeSlide.hasClass('wh') && sliderArea) {
      const sliderRect = sliderArea.getBoundingClientRect();
      swiperActive = sliderRect.bottom > 0 && sliderRect.top < window.innerHeight;
    }

    // スクロール判定
    let scrollHeaderActive = false;
    let scrollBodyActive = false;
    scrollTargets.forEach(target => {
      const rect = target.getBoundingClientRect();
      if (rect.top < headerHeight + offsetHeader && rect.bottom > offsetHeader) {
        scrollHeaderActive = true;
      }
      if (rect.top < headerHeight + offsetBody && rect.bottom > offsetBody) {
        scrollBodyActive = true;
      }
    });

    // header-wrapper 制御
    if (swiperActive || scrollHeaderActive) {
      headerWrapper.addClass('wh-change');
    } else {
      headerWrapper.removeClass('wh-change');
    }

    // body 制御
    if (swiperActive || scrollBodyActive) {
      body.addClass('wh-change');
    } else {
      body.removeClass('wh-change');
    }
  }

  fadeSwiper.on('slideChangeTransitionStart', updateHeader);
  window.addEventListener('scroll', updateHeader);
  window.addEventListener('resize', updateHeader);
  updateHeader(); // 初期チェック
});